const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopicsTransparentSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#2F5D7B",
    d: "M989.8 844.8c.4.6.7 1.1 1.2 2.4.6 1 1 1.2 1.4 1.5.4.5.7 1 1 2.5a51 51 0 0 0 2.3 7.3c4.8 11.8 7 23.8 4 37-2.4 8.4-5 16.3-7.5 24.2-.6 1.4-1.2 2.9-2.7 4.6a65.2 65.2 0 0 0-5.2 6.8c-8.5 11.1-20.5 16.4-34.5 20.3-2.8 0-4.5-.3-6.2 0-16.6 3.3-31.7-1.4-46.3-8.8-1.6-.9-3.6-1-5.4-1.4v-.4c-1-.9-2-1.3-3-1.7 0 0 .3-.2.2-.5-.7-.6-1.3-1-2-1.3-20.6-18-31.9-42.9-47-65a1269.1 1269.1 0 0 1-32.4-50.2 42.9 42.9 0 0 0-4.4-6.6v-.5c-.8-1.4-1.7-2.3-2.6-3.3l.1-.5c-.9-1.4-1.8-2.4-2.7-3.4l.1-.5a24.8 24.8 0 0 0-5.6-4.7H108.4c-2.7 0-5.4.7-8 1a72.8 72.8 0 0 1-62.9-44A142 142 0 0 1 31 742c.5-7.9 1.2-14.8 1.2-21.7V172.6c.1-7 .7-14.1.8-21.2 0-2.8-.4-5.6-.7-8.4a438 438 0 0 1 11.2-23c1.5-1.5 2.1-2.8 2.8-4.1 0-.4.2-.8 1.3-1.2 3.8-3.5 7-7 10.1-10.4h.5l1.6-1.7h.6a9.5 9.5 0 0 0 2.4-2.2s.2.2.6.1c7.5-1.9 13.3-8.8 21.8-5.4.3.1 1.2-.6 1.4-1.1 2.6-6.8 9.1-5.4 13.7-5.5 17-.4 34 .5 51 .5h407.3c90.2 0 180.4 0 270.7.2 7.6 0 15.3 2.3 23 3.5l14.2 2.6.1.4 2.5 1v.5c1.3.9 2.6 1.4 3.9 2 0 0-.2.1-.1.5 1.3 1 2.6 1.5 3.8 2.1v.5c3 2.7 6 5 9 7.2.5.1.8.3 1.1 1.4a36 36 0 0 0 3.7 5.1c3 4.4 6 8.7 9.2 13.8.6 1 1 1.3 1.2 1.6 0 0 .2.5.2 1.2 8 20.8 6.3 41.9 6.3 62.7v523c0 1.9-.3 3.9.2 5.7.2 1 1.7 1.8 2.7 2.7.4.1.7.3 1 1.5a8 8 0 0 0 1.6 2.3s-.2 0-.2.4a14 14 0 0 0 2 2.3l28 40.8c10 14.7 19.9 29.6 29.7 45 .1.9.4 1.2.7 1.5.4 0 .8.1 1 1.2a18 18 0 0 0 2.7 3.9v.4c.8 1.5 1.7 2.5 2.6 3.4l-.1.5c.9 1.4 1.8 2.4 2.7 3.4l-.1.4a24 24 0 0 0 2.6 3.4v.5a19 19 0 0 0 2.6 3.4v.4c.9 1.4 1.8 2.4 2.7 3.4M69.4 766.1c.4.3.8.5 1.3.6 0 0-.2 0 0 .7l1.2.6.3.7a43 43 0 0 0 3.5 2l.3.7a43 43 0 0 0 3.7 1.8s-.2 0 .4.7a542 542 0 0 1 20.2 6.8s-.1.2.2 1.2c2.6.5 5.2 1.4 7.8 1.4h660.9c2.5 0 5-1.4 7-3-6.7-10-14-19.7-20.2-30.1-5.2-8.8-7.7-18.8-.7-27.6 4.6-5.7 3.4-9.7-.4-15.2-6.3-9.4-12.4-18.9-19-28-3.3-5-8.2-6-14.1-4.3a207.6 207.6 0 0 1-163.4-19 188 188 0 0 1-79-82.4c0-.6.3-1.3.1-1.8-5-12-10.1-24-15.4-35.8-.5-1.2-2-2-3.4-3.6-.1-.5-.2-1 1.1-1.7 6.4-.6 13-1.6 19 1.1a8 8 0 0 1 3.8 4.3c.4 1.1-.6 3.7-1.5 4-1.6.7-3.7.2-5.6-.1-1-.2-2-1-3-1.4L473 540c5.3 9.3 9.1 19.6 20.6 25.2l-.4-7c.8 0 1.4 0 1.6.2 1 1.6 1.7 3.4 3 4.9 1.3 1.6 3 2.8 5.3 4.8 11.4 18.2 24 35.3 41.3 48.5 16.8 13 35 23.4 55.1 31.8 6 3.2 11.8 7 20 5.3.5 0 1.1.1 1.8 1l3.4.2c1 .1 2 .2 3.1 1.2.3.4.5.9.8 1 19.7 3.6 39.5 3.8 59.4 1.6.9-.1 1.6-1.6 3.4-2.4 1-.1 1.9-.2 3.2.4.8-.6 1.5-1.1 3.2-2 1 .1 1.9.1 3.3.8l4.3-1.8c.5 0 1-.1 2.2.5 6.8-1.9 13.8-3.4 20.5-5.7 3-1 5.7-3.5 9.2-6a180.1 180.1 0 0 0 100.3-105.3c.4-1 1-1.9 2.4-3 1.4-5 2.9-10.2 4.3-16.2.2-.5.4-1 1.5-1.8 1.7-5.7 3.5-11.4 4.9-17.1.3-1.4-.8-3-1.5-5.4.1-.6.3-1.1 1.4-2l-.1-18.8c0-2.1.1-4.3 1-7.2-1.2-14-2.3-28-3.7-42 0-1.3-2-2.4-3.5-4.4-7.2-28-22-52.2-40.3-74.2a153.5 153.5 0 0 0-42.1-36 12 12 0 0 0-2.1-.7l-.4-.7-4.8-1.8-.2-.8c-.8-.2-1.6-.4-2.6-1.3-.7-.2-1.4-.3-2.5-1.3a232.9 232.9 0 0 0-50.1-19.4c-6.7-1.4-13.4-3.6-20.2-4a202.5 202.5 0 0 0-86 12.1c-2 .8-3.4 2.7-5.8 4.5l-11.4 5.8a216.5 216.5 0 0 0-74.4 68.8l-7.7 8.5c-5.7-7.2-5.6-8.5 1-13.8 1.7-1.4 3.6-2.8 5.3-4.4 3.8-3.3 4.7-11.2 1.1-13-6.8-3-5.1-6.9-2-11.5.8-1.3.8-3.1 1.3-4.5 0 0-.1-.2.8-.1L521 313c1.2-1.2 1.7-3.2 3-5.6a201 201 0 0 1 139-52.3c51.8-.1 98 17.1 137.5 51.4 23 20 41.7 43.3 53.6 71.9 1.5 2.8 3 5.6 5.1 9 .2.6.4 1.3 0 2.5.6 1.1 1.3 2.2 2.1 4v2.7c2.5 9.8 5 19.6 7.7 29.4.2.7 1.5 1.2 2.4 2.7 0 .6 0 1.1-.6 2.3.7 2 1.4 4 2.2 6.9 0 1.3 0 2.6-.7 4.4.6 1.2 1.3 2.4 2 4.7 0 2.5 0 5.1-.8 8.2l2.1 5.7c0 1.4 0 2.8-1 4.8 0 6.2-.2 12.5-.5 19.8 0 2.6 0 5.2-.8 7.9 0 .8-.2 1.7-.5 3.7 0 1.7.5 3.4.2 5-2.5 11.2-5 22.4-8 34.4a202.4 202.4 0 0 1-41.8 74c-1.6 2.3-3.3 4.5-4.8 6.9l-1 .4c-4.3 5-2.9 11 3.9 15.5l.1.8 2.2 2v.7c.5.6 1 1.2 1.6 1.6 0 0-.2 0 .1.8l3.3 3.5v.5s.4.3.7 1c4.8 5 9.3 10 14.3 14.7 1.6 1.4 5.1 2.6 6.7 1.8 6.3-3.1 11-.3 14.9 3.7 6.7 6.7 12.8 14.1 19.3 22 .8.6 1.7 1.2 3.2 1.1.2-2.3.4-4.6.4-7 0-148.5 0-297-.3-446.4-2.7-.4-5.3-1.2-8-1.2H322.7l-262.4.1c-3 0-6 1.8-9.7 3.3-.1 1.4-.3 2.8-1 4.6.2.7.4 1.4.7 3.3 0 19.3 0 38.6-.7 58.4l.7 4.5c0 8.6 0 17.2-.7 26.3l.7 4.5c0 8.6 0 17.2-.5 26 .1.4.3.7.5 2.1 0 2.3 0 4.5-.7 7.1.2.7.4 1.4.7 3.3 0 11.6 0 23.2-.8 35.4l.8 7c0 11.1 0 22.3-.8 34l.8 6.8c0 1.4 0 2.9-.7 4.8l.7 5.5c0 1.4 0 2.8-.7 4.8l.7 5.5c0 1.8 0 3.6-.6 5.8l.6 3.3c0 30 0 60-.7 90.5l.7 4.4c0 4.8 0 9.6-.5 14.6.1.3.3.6.5 2.2 0 24.4 0 48.9-.7 73.7.2.7.4 1.3.7 3.2 0 3 0 6.2-.7 9.6l.7 3.2c0 4 0 7.9-.5 12 .1.4.3.7.5 2.2 0 9 0 18-.4 27.3.1.4.3.7 1 .7a2 2 0 0 1 1.4-1s.5.3.4 1.3a1124.2 1124.2 0 0 1 6.8 21.3c.2.4.6.6 1 .6l.2.6 1 .7.2.8a51 51 0 0 0 2 2.1l.1.8 1.6 1.5.1.6c.4.3.8.6 1.2.7 0 0-.2 0 0 .7l1.3.6s-.2 0 0 .7c.4.2.8.5 1.2.5l.1.7M887.7 209l.3-47.9c0-.9-.9-1.7-2-3.4-3.6-24.6-23.2-45-45.3-47.4l.2-1.3c-1.7-.2-3.3-.5-5-.5H104.4a19 19 0 0 0-6.7 1.7s-.2.5-1.2.6a46.6 46.6 0 0 0-25 11.7C60.8 131.2 56 143 52 156.5c-.2 17.5-.4 35-.4 52.6 0 .6 1 1.2 2.8 2h5.7c273 0 545.8 0 818.8-.2 2.5 0 5-.8 7.9-1.2 0 0 .2 0 .8-.8m-31.3 645.8c11.5 17.8 22.5 35.8 34.6 53a55.2 55.2 0 0 0 17 16.1c19 10.8 37.3 9.1 54.7-4.8 16.7-13.4 22.5-41.2 9.4-59.2-7.7-10.5-14.7-21.5-22-32.2-4-5.8-7.9-11.6-12-18.2-1.5-2-3.2-4-4.6-6.1-16.4-24.6-32.7-49.3-49.2-73.9L853.5 684c-2.9 1.4-4.7 2-6.3 3-22.7 15.5-45.5 30.8-68 46.5-1.3.8-1.6 4.1-1.2 6 .3 2 2.1 3.7 3.3 5.4 15.6 22.2 31.4 44.1 46.7 66.4 9.7 14 18.7 28.4 28.4 43.4m-73.1-205L755.4 666l6.3 9.4c3.9 6.3 8.2 12.4 11.4 19 5 10.5 4.7 10.6 14.4 4.1l2.1-1.4c12-8 24-16 36-24.2L798 638.6l-14.6 11Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M866.2 95c-4.4-.5-9.2-1.5-14-2.3-7.6-1.2-15.3-3.4-23-3.5-90.2-.2-180.4-.1-270.6-.1H151.3c-17 0-34-1-51-.6-4.6.1-11.1-1.3-13.7 5.5-.2.5-1.1 1.2-1.4 1-8.5-3.3-14.3 3.6-22 5.5a67.6 67.6 0 0 1 43.6-15l715.9-.1c15.2 0 29.7 2.2 43.5 9.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#31607E",
    d: "M32.2 143.5c.4 2.3.9 5.1.8 8-.1 7-.7 14-.7 21.1-.1 24.8 0 49.6 0 74.4l-.1 473.3c0 7-.7 13.8-1.1 21.2-.9-5-2.4-10.4-2.5-15.8l.1-557.8c0-8 2.1-16 3.5-24.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M910.1 726.2c-.8-.4-2.3-1.1-2.5-2.2-.5-1.8-.2-3.8-.2-5.7v-523c0-20.8 1.6-41.9-6.3-62.4a62 62 0 0 1 8.8 35.5V387a6247104.8 6247104.8 0 0 0 .2 339.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002144",
    d: "M101 803.7c2-.4 4.7-1 7.4-1 227.9-.1 455.7-.1 684.2.1.6.3.6.9.6.9l-158.5.1H108.6l-7.7-.1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M892.1 941.6c1.6 0 3.6.1 5.2 1 14.6 7.4 29.7 12.1 46.3 8.8 1.7-.3 3.4 0 5.7 0a49.2 49.2 0 0 1-34.8.3c-7.7-2.2-14.7-6.4-22.4-10.1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M999.8 895c3-12.7.8-24.7-4-36.5-1-2-1.6-4.3-2.4-7 8 8.4 9 19.4 9.9 30.4.3 4.2-.8 8.4-2 12.9l-1.5.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M999.8 895.5c.2-.5.5-.5 1-.5.5 9-2.8 17-8.2 24.5 2.1-7.7 4.7-15.6 7.2-24Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M57.3 104.4c-2.7 3.3-5.9 6.8-9.5 10.2 2.8-3.3 6-6.7 9.5-10.2Zm828.3 4.8a80.6 80.6 0 0 1-8.9-7c2.9 2 5.8 4.2 8.9 7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M984.7 931c1.1-2 2.6-4.2 4.5-6.5a36 36 0 0 1-4.5 6.4ZM803.4 816a30 30 0 0 1 4 5.7 30.1 30.1 0 0 1-4-5.8Zm-9.8-12.2c-.4-.1-.4-.7-.4-1 1.7 1.2 3.4 2.7 5 4.6-1.4-.8-2.8-2.2-4.6-3.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M890.5 115.6c-1.2-1-2.4-2.5-3.6-4.4 1.2 1 2.4 2.5 3.6 4.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154868",
    d: "M989.7 844.4c-.8-.6-1.7-1.6-2.7-3 .9.5 1.7 1.6 2.7 3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M872.7 98.8a9 9 0 0 1-3.7-1.7 9 9 0 0 1 3.7 1.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154868",
    d: "M987 840.6a9.9 9.9 0 0 1-2.5-3c.8.5 1.6 1.5 2.5 3Zm-2.6-3.9c-.7-.6-1.6-1.5-2.5-3 .8.6 1.6 1.6 2.5 3Zm-2.5-3.8a11 11 0 0 1-2.6-3 11 11 0 0 1 2.6 3Zm-2.6-3.9a7.9 7.9 0 0 1-2.5-3c.8.6 1.6 1.6 2.5 3Zm-2.6-3.8c-.7-.6-1.6-1.7-2.5-3.2.8.6 1.6 1.7 2.5 3.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M876.5 101.5c-1-.3-2.3-.9-3.6-2 1.1.3 2.3 1 3.6 2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M800.8 812c.8.7 1.7 1.6 2.6 3.1a10 10 0 0 1-2.6-3Zm-2.6-3.8c.8.6 1.7 1.6 2.6 3a8 8 0 0 1-2.6-3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M46 116c-.4 1.2-1 2.5-2.1 3.8.2-1.1 1-2.3 2-3.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M889.1 939.4c.8.1 1.8.5 2.8 1.4-.8 0-1.7-.5-2.8-1.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M62.5 100.5c-.3.7-1 1.5-2.1 2 .3-.7 1-1.3 2-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M914.7 732.9c-.6-.3-1.3-1-2-2.1.7.3 1.3 1 2 2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M868.8 96.4c-.5 0-1.2-.2-2.2-.8.5 0 1.2.2 2.2.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M887.2 937.7c.6 0 1.2.3 1.8 1-.6 0-1.2-.3-1.8-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34617E",
    d: "M59.4 102.7c0 .4-.5 1-1.3 1.6 0-.5.5-1 1.3-1.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M912.8 730.2c-.4-.2-1-.8-1.5-1.7.4.1 1 .7 1.5 1.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154868",
    d: "M992.3 848.3c-.3.1-.7-.2-1.3-.8.3 0 .7.2 1.3.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M901 131c-.4.1-.7-.2-1.1-.8.3 0 .7.2 1 .9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154868",
    d: "M973 820.2c-.2 0-.5-.3-.5-.8.1-.1.4.5.5.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBE1F6",
    d: "m460.4 531 .5 2.3c5 12.8 9.8 24.7 14.4 37.2l-.4 115.3c0 15.1 9.2 24.3 24.3 24.3h249.4c2 0 4.2-1.2 6.3-1.8 3.8 4.6 5 8.6.4 14.3-7 8.8-4.5 18.8.7 27.6 6.1 10.4 13.5 20.1 19.8 30.6-53.2.3-106 .2-158.8.2H100.2v-.9c-7-2.7-13.8-4.8-20.7-7 0 0 .2 0 .1-.4-1.4-1-2.7-1.5-4-2 0 0 .1 0 0-.4-1.3-1-2.5-1.6-3.8-2.3v-.3l-1.3-1s.2 0 0-.3l-1.3-1s.1 0 0-.2l-1.3-1s.2 0 0-.3l-1.3-1s.2 0 0-.3c-.4-.5-.8-.8-1.2-1l.1-.4a8.1 8.1 0 0 0-1.7-1.9v-.4a6.6 6.6 0 0 0-2.3-2.4s.2 0 0-.3a7 7 0 0 0-1.1-1v-.4a2 2 0 0 0-1-1s-.2-.5-.2-1.3c-1.7-10-5-19-5-28.2-.2-160-.2-320-.1-480 0-2.7.3-5.5 1-8.4l612.6-.1c72.5 0 145 0 217.6.8l.2 4.4v436.5c0 2.7-.7 5.4-1.1 8.2-6.4-7.2-12.5-14.6-19.2-21.3-4-4-8.6-6.8-15-3.7-1.5.8-5-.4-6.6-1.8a161.9 161.9 0 0 1-15-16l.1-.7a16.2 16.2 0 0 0-3.7-3.7s.2-.1.2-.5c-.6-.9-1.1-1.4-1.7-2 0 0 .1.2.2-.3-.8-1-1.7-1.7-2.5-2.4l.1-.4-3-15.5h.5c2-2.5 3.6-4.9 5.2-7.3a215.6 215.6 0 0 0 41.6-74.1c1.5-1.7 2.8-2.8 3-4.1 3.2-15.3 7.6-30.5 9-46a193 193 0 0 0-5-65c-1-3.5-3.1-6.5-5-10.2l-6.3-15.2v-2.3c-.6-1.8-1-2.8-1.5-3.8a36 36 0 0 0-.9-2.8l-4.1-8.8a206 206 0 0 0-54.3-71.3A203.5 203.5 0 0 0 663 255c-52.4 0-99.5 16.6-139.6 52.9a6097 6097 0 0 0-23 23.4s.1.2-.3.3c-4 4.6-8 8.8-11.3 13.6A203.2 203.2 0 0 0 451 452.6c-1.2 26.5 1 52.8 9.4 78.3m-203.7 21.5s-.2 0-.2-1c-3.7-12.9-9.5-18-22-18.2a7229 7229 0 0 0-91.7 0c-10.4 0-20.1 8.5-20.7 17.5a336 336 0 0 0-1.2 25.6c.3 36.5 1 73 .9 109.6 0 15 8.8 23.8 23 24 29.7.6 59.5.4 89.2 0 11.3 0 19.7-7 22-16.4 0 0 .6 0 1.5-.7.2-1 .6-2 .6-3.1V557.1c0-1.6-.9-3.2-1.4-4.7M406.3 481c13.7-3.5 19.8-11 19.8-25V323.9c0-12.4-6-20.8-20.7-20.8-87.9.4-175.7.2-263.6.2-14.3 0-21 6.7-21 21 0 42.2.3 84.3-.2 126.4-.2 15.1 4 26.3 20.2 31.8 1.7.2 3.3.5 5 .5h253.9c2 0 4-.9 6.6-2m-38.5 52.2h-51.3c-14.5 0-22.5 8.2-22.5 22.7v128.3c0 16.3 8.3 25.6 24.4 25.8 27.8.4 55.6.4 83.4 0 18.5-.3 26.1-10.4 25.9-26.8-.6-42.4-.2-84.7-.2-127 0-14.6-8.5-23-23.1-23h-36.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5C97C7",
    d: "M53 155.8a59 59 0 0 1 18.3-33.4 43.4 43.4 0 0 1 26-11.3c2.8.6 4.6 1 6.5 1h730.5c2.2 0 4.4-1 6.6-1.4 21.9 1.8 41.5 22.3 45.5 48 .4 17.6.6 34.3.7 51H276c-70.9 0-141.9 0-212.9.2-6.7 0-8.3-1.9-8-8.3.5-11 .2-22.2 0-33.3 0-2-1.3-4-2.1-6.5-.2-2.4-.2-4.2-.2-6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBE1F6",
    d: "m849.7 492-.5 2.5-4.2 21.9-.9 2.4-5 15.6-1.4 2.8A181 181 0 0 1 736.6 643c-7.3 2.6-13.9 4.7-20.7 6.6-11 1.2-21.6 2.8-32.2 4.3-24.6 3.3-48.7.6-72.6-5.3-1.7-.4-3.7.4-6 .6l-5.7-1.5c-19.8-7.6-38-18-55-31a180.8 180.8 0 0 1-41.7-49.2 186.3 186.3 0 0 1-27.3-95.6c0-10 .5-19.9.8-30.3.1-1.4.2-2.3.7-3.5 5.2-16.4 10-32.5 15-48.8 0 0 0-.4.4-.8 3.6-6.2 6.9-12.2 10.1-18.1a205.5 205.5 0 0 1 73.5-68.8l12.3-6.2c12-3.5 23.2-6.7 34.7-9.5a8 8 0 0 0 3.4.8c17.1-.8 34.4-3.1 51.4-2 15.2 1 30.4 5.1 45.3 8.9 9.1 2.3 17.8 6.5 26.7 9.8.8.2 1.5.3 2.5 1.2 1.1 1 1.9 1.1 2.6 1.4l.1.4c1.8 1 3.5 1.5 5.1 2 0 0-.1 0 0 .4.8.6 1.6.8 2.4 1 16.3 9 30 21.3 41.7 35.4 18.3 22 33 46.1 40.5 75.1l6.2 46.2-.3 7.6-.8 18M625 622.8l.5.8c11 1.9 22 5.2 33 5.4 13 .1 25.8-2.2 38.6-4 3-.4 5.8-2.8 9.6-4.7 18.4-5.6 35.2-14 50.4-25.9 35.5-27.8 56-64.1 62.9-109.1.4-.7 1.2-1.3 1.2-2 .1-9.3.2-18.6 0-27.9 0-1-1.5-2-2.6-4.2a160 160 0 0 0-30.6-76.4 155.7 155.7 0 0 0-192.6-46.4 163.1 163.1 0 0 0-68.9 62.4c-1.4 1.8-3.3 3.4-4.3 5.4-10.3 21-17 43.1-17.7 66.6-.6 21.2 2.5 42 10.2 61.9.7 1.7 2.5 3 4.3 5.2.3 1 .7 2 .3 3.5l3 4c15.5 34.3 41.7 57.8 74.8 75.6a55 55 0 0 0 28 9.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FB9DC",
    d: "M754.9 707.8c-2.1 1-4.2 2.2-6.3 2.2H499.2c-15.1 0-24.3-9-24.3-24.2 0-38.2.2-76.5.7-115 1.3.9 2.2 2.1 3.1 3.4a194.7 194.7 0 0 0 79.6 82 207.6 207.6 0 0 0 163.5 19c6-1.8 10.8-.7 14.2 4.1 6.5 9.2 12.6 18.7 18.9 28.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7BB5",
    d: "M856 854c-9.3-14.3-18.3-28.7-28-42.7-15.3-22.3-31.1-44.2-46.7-66.4-1.2-1.7-3-3.4-3.3-5.3-.4-2-.1-5.3 1.1-6.1 22.6-15.7 45.4-31 68.1-46.4 1.6-1 3.4-1.7 6.3-3l30.8 45.3c16.5 24.6 32.8 49.3 49.2 73.9 1.4 2.1 3 4 4.2 6.5-11-2-11.7 7.8-16.2 13.3l-6.7-1.9 1.6-9.8c-4 3.1-7.4 5.6-10.6 8.5-2.8 2.5-5.2 5.5-8 8.5l-3.8-1.1c1.4 3.9 3.7 6.5 5.7 9.4.5.8.3 2.3 0 3.3-.1.4-1.6 1-2.1.7-2.7-1.4-7-2.8-7.5-4.9-1.7-8.6-9.4-5.4-13.5-8.8l-1.6 2 4.8 3.8-11.3 7.7 3.4 3.4-5.1-1-.6 1.6 8.8 4 5-4c0 3.6-.2 6.2-.4 9.7-6.6-3.5-14.6-2.3-19-9.5-.3-.5-2.2-.8-2.6-.4-.7.7-1 2-1.2 3.1-.4 2.2-.6 4.4-.8 6.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3976B2",
    d: "M856.2 854.3c0-2.5.2-4.7.6-6.9.1-1 .5-2.4 1.2-3.1.4-.4 2.3-.1 2.6.4 4.4 7.2 12.4 6 19 9.5l.5-9.6-5.1 4-8.8-4 .6-1.6 5 .9a5417 5417 0 0 0-3.3-3.4l11.3-7.7-4.8-3.7 1.6-2.1c4.1 3.4 11.8.2 13.5 8.8.4 2.1 4.8 3.5 7.5 5 .5.2 2-.4 2.1-.8.3-1 .5-2.5 0-3.3-2-2.9-4.3-5.5-5.8-9.4l4 1.1c2.7-3 5.1-6 8-8.5 3-2.9 6.5-5.4 10.5-8.5l-1.6 9.8 6.7 2c4.5-5.6 5.3-15.5 16.3-13a367 367 0 0 1 12.3 17.4c7.3 10.7 14.3 21.7 22 32.2 13.1 18 7.3 45.8-9.4 59.2-17.4 14-35.7 15.6-54.6 4.8a55.2 55.2 0 0 1-17-16c-12.2-17.3-23.2-35.3-35-53.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49748D",
    d: "m885.2 235.9-217.5-.1a882022 882022 0 0 0-613.6 0c-1-.4-1.8-.4-2.6-.3 0 .2-.3.3-.3.3 3-1 6-2.8 9-2.8l262.4-.1h557.3c2.6 0 5.2.8 7.7 1.8-.5.6-.8.7-1.3.8-.6 0-.9.1-1.1.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E5D7B",
    d: "M502 370.3c-2.8 6-6.1 11.9-9.8 17.6-1.8-1-3.3-2.6-4.5-2.4-4.1.7-8 2-12.3 3l10.4 7 5.9-6.1c-4.8 16.1-9.6 32.2-15.2 48.3-.8-2.6-.8-5.3-.8-6-5.4-2.4-10.9-3.3-14-6.6-1.4-1.5 1.9-7.4 3-11.3.4-1.8 1.4-3.8 1-5.5-.2-1.4-2-2.4-4.1-4.6-2 9.4-4.2 17-5.3 24.6-1 7.8-5.7 16.4 3 23l-.4 1.4-5.7 2a244 244 0 0 0 7.2 67.6c2.2-2.4 3.5-4 5-5.3 5-4.5 7.8-3.5 9.7 3 .7 2.5 2.8 4.5 4.3 6.8l1.3-1-6.3-28.4c-2.8-.3-5-.5-7-1-.5-.1-.8-2.6-.7-2.7l7.3-1.9c-2.6-7.7-2.6-16-1.8-24.3 0-1-1.4-2-2-3a21.7 21.7 0 0 1-1.9-17.8l3.6 9 4.3-13.7c-.3 10-.9 19.9-.8 29.8a187 187 0 0 0 27 95.3c-1.4-1-3.2-2.2-4.6-3.8-1.2-1.5-1.9-3.3-3-5l-1.5-.2.4 7c-11.5-5.5-15.3-15.8-20.6-25.1l1.4-1.3c1 .5 2 1.2 3 1.4 1.9.3 4 .8 5.6.2 1-.4 1.9-3 1.5-4.1a8 8 0 0 0-3.7-4.3c-6.2-2.7-12.7-1.7-19.8-1a200.5 200.5 0 0 1-10-78.3c1.8-39.5 15.4-75 37.7-107.3 3.3-4.8 7.3-9 11.3-13.7 0 1.4 0 3.2-1 4.5-3 4.6-4.7 8.4 2.1 11.6 3.6 1.7 2.7 9.6-1 13l-5.5 4.3c-6.5 5.3-6.6 6.6-1 13.8 2.7-2.9 5.2-5.7 8.3-8.5m-25.2-1c-2 6 1.8 6.6 6.9 7L488 361c5-.5 5-.6 3.6-6.3a26 26 0 0 0-14.8 14.5m-.9 40.6c6.6-.3 8.7-3.4 8.4-12.3-3.3.3-6.7.9-10 .8-3.9-.2-5.4 2-4.3 5 .8 2.4 3.2 4.3 6 6.5m-4.3-26-6 9.3 2.9 1.4a60 60 0 0 0 3.1-10.8m6 31.2-1.2 5.7h2.4c-.2-2-.4-4.2-1.2-5.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C79B2",
    d: "m783.7 649.4 14.2-10.8 27.8 34.4-36 24.2-2.2 1.4c-9.7 6.5-9.4 6.4-14.4-4-3.2-6.7-7.5-12.8-11.4-19.1l-6.3-9.4 28.3-16.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66A1D4",
    d: "M840.8 110.4c-2.1.8-4.3 1.7-6.5 1.7H103.8c-1.9 0-3.8-.4-6-1-.4-.5-.2-1 .4-1.2 64-.3 127.2-.3 190.4-.3h552l.2.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154868",
    d: "M100.4 781.4c172-.4 344.3-.4 516.6-.4l159 .2c-1.9.7-4.3 2-6.8 2l-344.2.1H108.3a25 25 0 0 1-8-1.9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6FACDE",
    d: "M53.2 162.3c.7 2 2 4 2 6 .2 11.1.5 22.2 0 33.3-.3 6.4 1.3 8.3 8 8.3 71-.3 142-.2 213-.2H886c-2 .4-4.6 1.2-7.1 1.2l-818.8.1c-1.9 0-3.8 0-6.3-.5-.7-16.5-.7-32.3-.7-48.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFFAFF",
    d: "M54.5 236c-.1 2.8-.4 5.6-.4 8.4 0 160-.1 320 .2 479.9 0 9.1 3.2 18.3 4.9 28-2.2-6-4.4-12.6-6.5-20.2l-1-16.1c0-5.3 0-10 .3-15 0-1-.1-1.7-.4-2.9 0-1.9 0-3.2.5-5a313 313 0 0 0-.5-19.5c0-14.3 0-28 .4-42 .1-1.8 0-3.3-.3-5.4 0-11.8 0-23 .3-34.3 0-1-.1-1.6-.4-3 0-6.6 0-12.6.4-18.9 0-1.3 0-2.4-.4-4.1 0-7 0-13.5.4-20.2 0-1.4 0-2.5-.4-4.2 0-2.3 0-4 .4-6 0-1-.1-1.7-.4-3 0-17.3 0-34 .4-51 0-.9-.1-1.6-.4-2.8 0-2.4 0-4.1.3-6 0-.5 0-.9-.3-1.8 0-7.5 0-14.4.4-21.4 0-1-.1-1.7-.4-3 0-8.3 0-16 .4-24 0-1.4 0-2.5-.4-4.2 0-5.8 0-11 .3-16.2 0-.5 0-.9-.3-1.8 0-22.9 0-45.1.4-67.8.1-2.6 0-5-.3-7.8a74.6 74.6 0 0 0 0-15.5c0-8.3 0-16 .3-24.1a388.7 388.7 0 0 1 0-30.8c.1-4 0-7.6-.4-11.8 0-2.3 0-4 .6-5.8l2.2-.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17445B",
    d: "M840.7 109.3c-184 .4-368 .3-552 .3H98.2c1.6-.4 3.8-1.2 6-1.2H836c1.6 0 3.2.3 4.7 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002040",
    d: "M51.7 318.8c0 1.8 0 3.6-.2 6.4l.2 7.7c0 22.3 0 44.5-.2 67.7l.2 1.6c0 5.2 0 10.3-.2 16.6l.2 4c0 7.7 0 15.4-.2 24.1 0 1.6.2 2.2.2 2.8a24981.8 24981.8 0 0 1-.2 29.4c0 1.5.2 2 .2 2.7 0 16.7 0 33.4-.2 51.1 0 1.6.2 2.2.2 2.8 0 1.7 0 3.5-.2 6.3l.2 4c0 6.4 0 12.8-.2 20.3l.2 4c0 6 0 12-.2 19 0 1.7.2 2.2.2 2.8 0 11.2 0 22.3-.2 34.6l.2 5.2c0 13.7 0 27.4-.2 42.3l.2 19.3c0 1.4 0 2.7-.2 5 0 1.5.2 2.1.2 2.7 0 4.7 0 9.5-.2 15.4l.2 15.1c-.3.4-.6.8-1.2 1-.3 0-.3-.7-.3-.7v-28l-.1-1.5v-15.4a1436.7 1436.7 0 0 0 0-12.8v-95a172054.5 172054.5 0 0 0 0-100.1v-5a291.3 291.3 0 0 0 0-10.3v-11.6a27005 27005 0 0 0 0-41V240.5c.1-1.5.3-2.9.7-4.6.4-.2.7-.3.7-.1l.3.8-.3 6.4.2 11.5c0 6.9 0 13.8-.2 21.8l.2 9c0 7.7 0 15.5-.2 24.4l.2 9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFFAFF",
    d: "M885.3 236.6c.1-1 .4-1 1.2-.5.4 60.3.4 120 .4 179.9v272.3c-.7-.7-1.6-1.3-2.5-2.3.4-3 1.1-5.8 1.1-8.5V241c0-1.2 0-2.5-.2-4.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#07385A",
    d: "M887.4 688c-.4-90.5-.5-181.2-.5-272 0-59.8 0-119.6-.2-180 .1-.6.4-.7 1-.9.5 148.4.5 297 .4 445.4 0 2.4-.2 4.7-.7 7.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBE1F6",
    d: "M867.9 411.2c1.6 3.2 3.8 6.2 4.6 9.6a193 193 0 0 1 5 65c-1.3 15.6-5.7 30.8-8.9 46-.2 1.4-1.5 2.5-2.8 3.7 2.1-11 4.7-22.2 7.2-33.4.3-1.6-.1-3.3.2-5.7l1-3.1c0-2.6 0-5.2.4-8.7a277.2 277.2 0 0 0 1-24.6l-1.3-5.3V446c-.4-2-.9-3.1-1.3-4.1v-5c-.5-2.8-1-4.7-1.5-6.5l-.1-2.6c-1.2-6.2-2.4-11.4-3.5-16.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E6F6",
    d: "M749.6 302.9c-8.8-3-17.5-7-26.6-9.4-15-3.8-30-8-45.3-9-17-1-34.3 1.3-51.4 2.1-1 0-2-.3-3-1 11-1.6 21.8-3.7 32.5-3.8 14.6 0 29.1 1.4 43.7 2.2 17.4 4.2 34.3 9.7 50 18.9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M699.4 283.6c-14.5-.4-29-1.9-43.6-1.8-10.7 0-21.5 2.2-32.7 3.5l-34.6 9.8c1.2-1.2 2.7-3.1 4.6-3.9a202.5 202.5 0 0 1 86-12c6.8.3 13.5 2.5 20.3 4.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E6F6",
    d: "M605.6 649.2c1.8-.3 3.8-1 5.5-.7 24 6 48 8.6 72.6 5.3 10.6-1.5 21.2-3.1 31.7-4.2-2.8 1.7-5.6 2.8-8.3 3.9l-2.5.2c-1.8.4-2.9.8-3.9 1.1H697c-1.5.5-2 .9-2.7 1.3h-3.9c-11.4.4-21.8 1.3-32.2 1.2-10.2-.1-20.4-1.4-30.5-2.1-1-.1-2-.2-3.5-.7-1.4-.5-2.2-.5-3-.6-.5 0-1-.2-2.3-.7-4.9-1.7-9-2.8-13.3-4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M627.8 655.7c10 .2 20.2 1.5 30.4 1.6 10.4.1 20.8-.8 31.8-1.1-.3 1-1 2.4-2 2.5-19.8 2.2-39.6 2-59.3-1.6-.3-.1-.5-.6-1-1.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M851.2 466c-2.4-14.7-4.4-29.7-6.4-45.3 1 .6 3 1.7 3.1 3 1.4 14 2.5 28 3.3 42.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E5D7B",
    d: "M479 574c-1.2-1-2.1-2.3-3.3-3.8-5-12.2-9.8-24.1-14.6-36.5 1 .4 2.5 1.2 3 2.4a3097 3097 0 0 1 15.4 35.8c.2.5 0 1.2-.4 2Zm21.8-242.5c7-7.7 14.5-15.3 22.4-23.2-.4 1.5-.9 3.5-2.1 4.7a494.5 494.5 0 0 1-20.3 18.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M707.4 653.9c2.4-1.5 5.2-2.6 8.4-4l20.5-6.7c-2.4 1.8-5 4.2-8.1 5.3-6.7 2.3-13.7 3.8-20.8 5.4Zm160.2-243.2c1.4 5.7 2.6 11 3.7 16.6-.8 0-2-.6-2.3-1.3-2.7-9.8-5.2-19.6-7.7-30 2 4.4 4 9.4 6.3 14.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17445B",
    d: "M53 161.8c.2 16.4.2 32.2.2 48.6-.6 0-1.5-.7-1.5-1.3 0-17.5.2-35 .8-53 .4 1.5.4 3.3.6 5.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M887.4 209.3c-.4-16.3-.6-33-.7-50.3.4.3 1.3 1.1 1.3 2 0 16-.1 32-.6 48.3Zm-42 307c1-7 2.3-14 3.9-21.4.7 1.1 1.8 2.8 1.5 4.2-1.4 5.7-3.2 11.4-5.4 17.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M817.8 617.6c1.5 4.8 2.5 9.8 3.5 15.3-6.8-4.1-8.2-10.1-3.5-15.3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M605.2 649c4.6 1.4 8.8 2.5 13.3 4.1-7 2.2-12.9-1.5-19-5.1 1.7 0 3.5.5 5.7 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M850.2 491.9c-.3-5.6 0-11.2.4-17.4.2 5.4.1 11.3-.4 17.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M79.8 773.5a280 280 0 0 1 20.4 6.5 280 280 0 0 1-20.4-6.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M839.6 534.3c1.1-4.8 2.7-9.7 4.5-15-1.1 4.7-2.6 9.9-4.5 15Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M875 465.4c.4 5.9.2 12.1-.3 18.7-.3-6-.2-12.2.4-18.7ZM854.5 378a49 49 0 0 1 4.2 8.3 49 49 0 0 1-4.2-8.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2E9F3",
    d: "M52 731.8c-.4-4.7-.4-9.4-.4-14.6.5 4.2.8 9 1.1 14.4 0 .6-.5.3-.8.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M823.6 610.3a40.5 40.5 0 0 1-4.8 7c1.1-2.3 2.8-4.5 4.8-7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M871.1 430.7a19 19 0 0 1 1.9 5.7 20 20 0 0 1-1.9-5.7Zm2.8 24.3c.8 1.1 1.2 2.6 1.5 4.5-.7-1.1-1.3-2.7-1.5-4.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M825.2 638.8c1.1.7 2.4 1.8 3.5 3.4-1.3-.7-2.3-1.8-3.5-3.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E6F6",
    d: "M759.8 308c-1.4-.2-3-.8-4.9-1.8 1.4.2 3 .8 4.9 1.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M701 655.2c.7-.7 1.8-1 3.2-1.4-.7.6-1.9 1.2-3.2 1.4Zm158.5-265.5c.8.7 1.2 1.7 1.7 3a6.9 6.9 0 0 1-1.7-3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M75.8 771c1.1.2 2.4.8 3.8 1.8a8.7 8.7 0 0 1-3.8-1.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M872.6 442c.8.9 1.3 2 1.7 3.4-.7-.7-1.4-2-1.7-3.3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#376885",
    d: "M49.8 452.6c.3 1.4.4 3.2.3 5.5-.2-1.4-.4-3.3-.3-5.5Zm0-41.1c.3 1.5.3 3.2.3 5.5-.2-1.4-.4-3.3-.3-5.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M873.7 493.3c.3.8.1 1.5-.4 2.5-.2-.7 0-1.6.4-2.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E6F6",
    d: "M762.2 309.4c-.6.1-1.4-.1-2.2-.7.6-.1 1.3.2 2.2.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M61.7 756.8a5 5 0 0 1 2.2 2.1c-.8-.3-1.5-1-2.2-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#376885",
    d: "M49.8 474.4c.3 1 .3 2.4.3 4.2-.2-1-.4-2.5-.3-4.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M621.3 654.3c.7-.3 1.5-.3 2.4.2-.7.2-1.5.2-2.4-.2Zm73.2 2.1c.4-.7 1-1.1 2-1.5-.3.7-1 1.2-2 1.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#376885",
    d: "M49.8 464.1c.3 1 .3 2.4.3 4.3-.2-1-.4-2.5-.3-4.3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M821.3 633.7a5 5 0 0 1 2.3 2c-.8-.2-1.5-1-2.3-2ZM72 768.4c1 .3 2.3.9 3.6 2-1-.3-2.2-1-3.6-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#376885",
    d: "M49.8 302.4c.3.7.4 1.6.3 3a8 8 0 0 1-.3-3Zm0 30.8c.3.7.3 1.6.3 3a8 8 0 0 1-.3-3Zm0 246.4c.3.7.3 1.6.3 3a8 8 0 0 1-.3-3Zm0-206.6c.3.3.3.8.3 1.8-.2-.3-.4-1-.3-1.9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M63.9 759.7c.5.1 1 .6 1.6 1.5-.5 0-1-.6-1.6-1.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#376885",
    d: "M49.8 240.7c.3.4.3 1 .3 1.9-.2-.3-.4-1-.3-1.9Zm0 245.1c.3.4.3 1 .3 1.9-.2-.3-.4-1-.3-1.9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M823.6 636.4c.5.2 1 .7 1.5 1.7-.5-.1-1-.7-1.5-1.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E6F6",
    d: "M754.6 305.5c-.5.1-1.3 0-2.2-.7.5-.1 1.3.1 2.2.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#376885",
    d: "M49.8 674.5c.3.3.3.9.3 1.8a3 3 0 0 1-.3-1.8Zm0 12.8c.3.4.3 1 .3 1.9-.2-.3-.4-1-.3-1.9Zm.1 15.3c.2 0 .2.5.2.8-.1 0-.3-.3-.2-.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M828.6 643c.3 0 .6 0 .7.3-.3.2-.6 0-.7-.3Zm-758 124c.3 0 .7.2 1.2.8-.2 0-.6-.2-1.2-.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#376885",
    d: "M49.9 363.9c.2-.2.2.4.2.7-.1 0-.3-.3-.2-.7Zm.1 368.2c.2-.1.2.5.2.8-.1 0-.3-.3-.2-.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFFAFF",
    d: "M59.4 754.2c.4-.2.7 0 1 .7-.4.2-.8 0-1-.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M60.5 755.4c.2 0 .6.2 1 .8-.2 0-.5-.2-1-.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#376885",
    d: "M49.9 598.7c.2-.1.2.5.2.8-.1 0-.3-.4-.2-.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M65.5 761.9c.3 0 .7.2 1.2.8-.3 0-.7-.2-1.2-.8Zm1.2 1.3c.3 0 .7.2 1.2.8-.2 0-.6-.2-1.2-.8Zm1.3 1.3c.3 0 .7.2 1.2.8-.3 0-.7-.2-1.2-.8Zm1.3 1.3c.3 0 .7.1 1.2.7-.3.1-.7-.1-1.2-.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#90BADD",
    d: "M140 481.7c-15.4-4.7-19.6-15.9-19.4-31 .5-42.1.1-84.2.2-126.3 0-14.4 6.7-21 21-21 87.9 0 175.7.1 263.6-.3 14.7 0 20.7 8.4 20.7 20.8v132c0 14-6 21.6-20.7 25.5-89 .3-177.2.3-265.4.3Zm115.6 211.9c-2 9.3-10.3 16.3-21.6 16.4-29.7.3-59.5.5-89.2 0-14.2-.3-23-9-23-24.1.2-36.6-.6-73.1-.9-109.6 0-8.5.6-17 1.2-25.6.6-9 10.3-17.4 20.7-17.5 30.6-.2 61.1-.2 91.7 0 12.5.1 18.3 5.3 21.5 18.9-.9 2.3-1.7 4-1.7 5.8v128.9c0 2.2.8 4.5 1.3 6.8Zm112.8-160.4h36c14.6 0 23 8.4 23 23 .1 42.3-.3 84.6.3 127 .2 16.4-7.4 26.5-25.9 26.8-27.8.4-55.6.4-83.4 0-16.1-.2-24.4-9.5-24.4-25.8V556c0-14.5 8-22.7 22.5-22.7h52Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FB9DC",
    d: "M255.8 693.5c-.7-2.2-1.5-4.5-1.5-6.7V557.9c0-1.7.8-3.5 1.7-5.4.5 0 .7-.1.7.5v140.5h-.9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M140.4 482.1c87.8-.4 176-.4 264.7-.4-1.4.4-3.4 1.3-5.4 1.3H145.8a19 19 0 0 1-5.4-.9Zm116.6 211c-.3-46.3-.3-93-.2-140.2.4 1 1.2 2.6 1.2 4.2v132.6c0 1-.3 2-1 3.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E5D7B",
    d: "m520.1 533-1.3-4a151 151 0 0 1-8.9-89.3c3.7-16.8 11.6-32.7 17.6-49a156.6 156.6 0 0 1 68-62.3 155.7 155.7 0 0 1 192.6 46.4 160.9 160.9 0 0 1 30.8 77.5l.2 33.3a159.4 159.4 0 0 1-113.2 135c-6.6 1.3-12.3 2.4-18.3 3.2-9 .7-17.8 1.8-27 3-1 0-1.6-.1-2.3-.7-6.9-1-13.6-1.4-20.9-1.9l-12.3-1.5-.1-.3c-9.5-3.7-18.7-7-28-10.3-32.9-16.9-59.1-40.4-75-75.4l-1.9-3.7m228.1-165.4v-.8a427 427 0 0 1-10.2-6.9s-.1.1-.1-.8c-2.4-2-4.5-4.3-7.2-5.8-11.8-6.5-23.7-13.4-38.8-14-5.1-.8-10.3-1.6-16.1-3.2a137.5 137.5 0 0 0-64.6 9c-1.2.4-1.9 2-3.3 3.3h-1.6c-3.5 2.2-7 4.5-11.1 7.5a136.8 136.8 0 0 0-58.7 72.1c-4.6 7-6 14.8-5 24 0 1.4 0 2.7-.6 4.4l.7 3.1c-.1.6-.2 1.2-1.3 2-3 7.8-1.7 15.3 1.2 23.9l1.2 11.3c.4 1.9.9 3.7 1.3 6.6 4.7 12 9.2 23.9 14.3 35.6 1.2 2.7 4.2 4.6 6.3 7v.8l4.7 4.7c5.3 5.7 10.6 11.4 15.9 17.9l3.1 1.5c12.6 7.5 25.2 15 38 23.4 2.5.6 5 1.2 8.3 1.7 1 .4 2 .8 3.2 2.2.8.5 1.6 1.5 2.5 1.6 7.7 1.4 15.4 3.5 23.2 3.7 7.6.1 15.7 2.8 24-2.4 1.3 0 2.6 0 4.6.6 10.6-2.6 21.2-5 31.7-7.9 2.3-.6 4-3.2 6.7-5.4a145.6 145.6 0 0 0 52.7-43.8c1.2-1.1 2.8-2 3.5-3.4 4.5-9 9.2-17.8 13-27 1.7-4.4 1.6-9.5 2.2-15 .1-.3.2-.5 1.2-1 .8-1.1 2.2-2.2 2.3-3.5 2.5-19 3-37.9-1.7-56.6-.4-1.4-1.8-2.5-3-4.3 0-.3 0-.5.7-1.4.1-.8.7-1.8.4-2.4-5.6-12-11.2-24-17-36-.5-1-2.4-1.2-3.5-1.9v-.9a49.8 49.8 0 0 0-4.6-4.4c-.3-.3-.5-.7-.5-2L763 381c-3.1-3.2-6.3-6.3-9.6-10.4l-5-3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F5D7B",
    d: "M476.2 441.5c-1.2 4.5-2.5 8.6-4.3 14.2l-3.6-9c-1.9 7-1.2 12.5 1.9 17.8.6 1 2 2 2 3-.8 8.3-.8 16.6 1.8 24.3-3.1.8-5.2 1.3-7.3 2 0 0 .2 2.5.6 2.6 2.1.5 4.3.7 7.1 1l6.3 28.5-1.3.9c-1.5-2.3-3.6-4.3-4.3-6.7-2-6.6-4.7-7.6-9.7-3.1-1.5 1.3-2.8 2.9-5 5.3-5.8-23-7.8-45-7.2-67.6l5.8-2c0-.5.4-1.2.2-1.3-8.6-6.7-4-15.3-2.9-23 1-7.8 3.2-15.3 5.3-24.7 2 2.2 3.9 3.2 4.1 4.6.4 1.7-.6 3.7-1 5.5-1.1 4-4.4 9.8-3 11.3 3.1 3.3 8.6 4.2 14 6.6 0 .7 0 3.4.4 6.3.3 1.2.2 2.1.1 3.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E6F6",
    d: "M527 390.7c-5.5 16.3-13.4 32.2-17 49-6.7 30-3 59.9 8.5 89-1.2-1-3-2.3-3.7-4a157.3 157.3 0 0 1-10.2-61.9c.7-23.5 7.4-45.6 17.7-66.6 1-2 2.9-3.6 4.8-5.5Zm161 233.5 17.4-3.5c-2.4 1.5-5.1 3.9-8.2 4.3-12.8 1.8-25.7 4.1-38.5 4-11-.2-22-3.5-33.3-5.9a4070.8 4070.8 0 0 0 35.8 3.7l26.8-2.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F5D7B",
    d: "m491.8 389.2-6 6.2-10.4-6.9c4.2-1 8.2-2.3 12.3-3 1.2-.2 2.7 1.5 4.2 2.8v1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E6F6",
    d: "M597.1 612.5a404 404 0 0 1 28 9.9 48 48 0 0 1-28-9.9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCECFC",
    d: "M819.6 485.4a691 691 0 0 1-.6-32.6c.8.5 2.3 1.5 2.3 2.6.2 9.3.1 18.6 0 27.9 0 .7-.8 1.3-1.7 2.1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1E6F6",
    d: "M519.8 533.2c.8.8 1.3 1.8 2 3.2a8.5 8.5 0 0 1-2-3.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2E9F3",
    d: "M52.2 236.7c-.5-.2-.6-.4-.7-1 .8-.3 1.6-.3 2.6 0-.3.5-.9.7-1.9 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F5D7B",
    d: "M477 368.8c3-7.2 8.1-11.3 14.6-14 1.4 5.6 1.3 5.7-3.6 6.2l-4.3 15.2c-5-.3-9-.9-6.6-7.4Zm-1.6 41c-2.2-2.2-4.6-4-5.4-6.5-1-3 .4-5.2 4.3-5 3.3 0 6.7-.5 10-.8.3 9-1.8 12-8.9 12.3Zm-3.4-25.7c-1 3.7-2.2 7-3.4 10.4l-3-1.4c2-3.1 4-6.2 6.3-9Zm6 30.6c.5 1.7.7 3.8 1 5.9h-2.5c.4-1.9.8-3.8 1.5-6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2E9F3",
    d: "M52 693c-.3-5.5-.4-11.6-.4-18.2.3 5.6.6 11.7.5 18.3Zm0-438.8a81 81 0 0 1-.4-10.6c.3 3 .5 6.6.4 10.6Zm0 64.2a47 47 0 0 1-.4-8c.3 2.1.5 4.9.4 8Zm0-33.4c-.3-2.2-.4-4.8-.4-8 .3 2.2.5 5 .4 8Zm0 47.5c-.3-1.8-.4-4-.4-6.8.3 1.8.5 4.2.4 6.8Zm0 299.1c-.3-1-.4-2.5-.4-4.3.3 1 .5 2.5.4 4.3Zm0-209.1a7 7 0 0 1-.4-3.2c.3.7.5 1.8.4 3.2Zm0 123.2a7 7 0 0 1-.4-3.2c.3.7.5 1.8.4 3.2Zm0 24.3a7 7 0 0 1-.4-3c.3.6.5 1.7.4 3Zm0-120.5c-.3-.4-.4-1-.4-2 .3.3.5 1 .4 2Zm0 32.1c-.3-.4-.4-1-.4-2 .3.3.5 1 .4 2ZM52 592c-.3-.5-.4-1-.4-2 .3.3.5 1 .4 2Zm0-56.6c-.3-.3-.4-.9-.4-1.9.3.3.5 1 .4 2ZM52 701c-.3-.4-.4-1-.4-2 .3.3.5 1 .4 2Zm0-299c-.3 0-.4-.2-.4-.8.3 0 .4.4.3.9Zm0 70.7c-.3-.1-.4-.4-.4-.9.3 0 .4.4.3.9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4FBFF",
    d: "m681.5 601-5-.1c-17.1 1.4-33-.4-48.9-3.8a108.1 108.1 0 0 0-11.5-3.8l-38.4-23-2.5-1.8-16.4-17.7-4.2-5v-.4L535 501.9c-.8-2.4-1.6-4.3-2.4-6.2-.4-3.4-.8-6.9-1-11.3 0-8.3-.3-15.7-.4-23.2l.3-2.5V456c0-1.3-.1-2.6.4-4.7 2.1-8.3 3.8-15.9 5.4-23.4 10.4-31.2 30-54.8 58.5-72.5l11.4-7 1.3-.1c21.1-8 42-13 64-10.3 1.2.1 2.6-.7 3.9-1 5.1.7 10.3 1.5 16.1 2.8A156.2 156.2 0 0 1 738 360l.2.3 10 7.4s.1-.1.3.3c1.8 1.4 3.4 2.5 5 3.5 3.2 3.2 6.4 6.3 9.8 10.2 1.2 1.8 2 2.9 3 3.9 0 .4.2.8 1 1.6l4 5s.1-.2.2.3l19.3 40.5.1 1.5c5.7 21.7 6 42.8 1.4 64 0 .1-.2.3-.4 1.3-4.1 16.6-10.9 31-19.6 44.7a136.5 136.5 0 0 1-52.5 44.2c-5 2-9 4-13.3 5.3-8.2 2.5-16.6 4.6-25 7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M676.1 336.5c-1 .8-2.3 1.6-3.5 1.5-22-2.6-42.9 2.2-63.7 10.2.4-1 1.1-2.7 2.3-3a133.1 133.1 0 0 1 65-8.7Zm116.6 161.8c4-21 3.8-42-1.7-63.5.9.7 2.3 1.8 2.7 3.2 4.7 18.7 4.2 37.7 1.7 56.6-.1 1.3-1.5 2.4-2.7 3.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M627.7 597.6c15.8 2.9 31.7 4.7 48.3 3.3-6.8 5.3-15 2.6-22.5 2.5-7.8-.2-15.5-2.3-23.2-3.7-1-.1-1.7-1-2.6-2.1ZM535 502.3l19.6 43c-2-1.8-5.1-3.7-6.3-6.4-5-11.7-9.6-23.7-14-36 .2-.6.8-.6.8-.6Zm237.7 42.2a164 164 0 0 0 19.1-44.3c-.5 4.4-.4 9.5-2.2 14-3.7 9.1-8.4 18-13 26.9-.6 1.4-2.2 2.3-3.9 3.4Zm-34.8-184.9a171.6 171.6 0 0 0-44.8-19.8c14 .1 25.8 7 37.6 13.5 2.7 1.5 4.8 3.9 7.2 6.3Zm53.1 73c-6.7-13-13.1-26.3-19.7-40.1 1.1.2 3 .5 3.5 1.5 5.8 11.9 11.4 23.9 17 36 .3.5-.3 1.5-.8 2.6ZM681.8 601.3c8-2.7 16.4-4.8 24.6-7.3 4.3-1.3 8.4-3.2 13-5-1.5 1.5-3.3 4-5.6 4.7-10.5 3-21.1 5.3-32 7.6ZM537 428a235 235 0 0 1-5 22.8 29 29 0 0 1 5-22.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154868",
    d: "M530.8 461.4c.6 7.3.8 14.7.8 22.5-3-7-4.2-14.6-.8-22.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M687.6 623.8a553 553 0 0 1-26 3 388 388 0 0 1 26-3Zm-29.3 2.3c-6.4-.2-12.9-.9-19.9-1.7 6.3.3 13 .7 20 1.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M748.2 367.3a92 92 0 0 1-10.1-7c3.2 2 6.6 4.2 10 7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M606.8 348.3c-3 2.3-6.6 4.4-10.6 6.8 3-2.2 6.6-4.5 10.6-6.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M616.2 593.8c2.2.2 4.6.9 7.3 1.9-2.2-.3-4.7-1-7.3-2Zm-61.6-47.6a22 22 0 0 1 3.9 4.4 22 22 0 0 1-3.9-4.4ZM753.4 371a17 17 0 0 1-5-3c1.4.6 3.2 1.6 5 3Zm17.9 20.6c-1.3-1-2.5-2.4-4-4.3 1.3 1 2.7 2.4 4 4.3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154868",
    d: "M535.1 501.9c0 .4-.6.4-.8.4-.7-1.9-1.2-3.7-1.6-6 .8 1.3 1.6 3.2 2.4 5.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#235575",
    d: "M766.2 385.1c-1-.5-1.8-1.6-2.8-3 1 .5 1.9 1.5 2.8 3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D5070",
    d: "M575.2 568.9c.6 0 1.3.5 2.1 1.3a4 4 0 0 1-2.1-1.3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#154868",
    d: "M531.2 456.2c.4.4.4 1 .3 2-.3-.3-.4-1-.3-2Z",
    style: {
      strokeWidth: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicsTransparentSmall);
export default __webpack_public_path__ + "static/media/topics-transparent_small.3f28979b19dd8e3fc99ca45cf5e67d47.svg";
export { ForwardRef as ReactComponent };